<table style="table-layout: fixed; width: 100%;" class="table table-xs tableFixHead" id="park-report"
    *ngIf="reportData.length > 0">
    <thead>
        <tr>
            <th>#</th>
            <th>Plate#</th>
            <th>Engine#</th>
            <th>Chassis Number</th>
            <th>Maintenance Title</th>
            <th>Maintenance Description</th>
            <th>Last Location</th>
            <th>Last Location Time</th>
            <th>Maintenance Reason</th>
            <th>Start Date</th>
            <th>End Date</th>
            <th>Status</th>
        </tr>
    </thead>
    <tbody>
        <tr *ngFor="let maintenance of reportData;let index=index">
            <td>{{index+1}}</td>
            <td>{{maintenance.vehicle_detail?.plate_number}}</td>
            <td>{{maintenance.vehicle_detail?.engine_number}}</td>
            <td>{{maintenance.vehicle_detail?.chassis_number}}</td>
            <td>{{maintenance.title}}</td>
            <td>{{maintenance.description}}</td>
            <td>{{maintenance.last_location?.formatted_address}}</td>
            <td>{{maintenance.last_location?.receiving_date_time | date: 'dd-MM-yyyy HH:mm:ss'}}</td>
            <td>{{maintenance.reason_description}}</td>
            <td>{{maintenance.start_date | date: 'dd-MM-yyyy' +' '+ maintenance.start_time}}</td>
            <td>{{maintenance.end_date | date: 'dd-MM-yyyy' +' '+ maintenance.end_time}}</td>
            <td><span class="badge badge-secondary">{{geMaintenanceStatus(maintenance.status)}}</span></td>
        </tr>
    </tbody>
</table>